<template>
  <div class="tipo">
    <div class="centro">
      <h1>Consulta por Ordem Cronológica</h1>
      <BuscaSimplesCards
        titulo="Consultas Rápidas"
        :cards="cardsAtoAdministrativo"
      />
      <Loading v-if="carregando" />
      <ErroResultados v-if="!carregando && erro" />
      <PainelAnos
        v-if="!carregando && !erro"
        :anos="anos"
        :generateUrl="generateUrl"
      />
    </div>
  </div>
</template>

<script>
import Loading from "../../components/Loading";
import ErroResultados from "../../components/ErroResultados";
import PainelAnos from "../../components/PainelAnos";
import { mixinAtoAdministrativo } from "../../mixins/mixinAtoAdministrativo";
import IndexAtoAdministrativoApi from "../../services/IndexAtoAdministrativoApi";
import metaDados from "../../helpers/metaDados";

export default {
  name: "PorAnoAtoAdministrativo",
  metaInfo() {
    return {
      title: "Pesquisa de Ato Administrativo por ano",
      titleTemplate: "%s - Casa Civil do Estado de Goiás",
      meta: [
        {
          vmid: "description",
          name: "description",
          property: "description",
          content:
            "Pesquisa de Índice de Atos Administrativos por Ano - Decretos e Portarias de nomeação",
        },
        {
          vmid: "og:description",
          property: "og:description",
          content:
            "Pesquisa de Índice de Atos Administrativos por Ano - Decretos e Portarias de nomeação",
        },
        {
          vmid: "og:title",
          property: "og:title",
          content:
            "Pesquisa de Índice de Ato Administrativo por Ano - Casa Civil do Estado de Goiás",
        },
        {
          vmid: "og:type",
          property: "og:type",
          content: "article",
        },
        {
          vmid: "twitter:description",
          name: "twitter:description",
          property: "twitter:description",
          content:
            "Pesquisa de Índice de Atos Administrativos por Ano - Decretos e Portarias de nomeação",
        },
        {
          vmid: "twitter:title",
          name: "twitter:title",
          property: "twitter:title",
          content:
            "Pesquisa de Índice de Ato Administrativo por Ano - Casa Civil do Estado de Goiás",
        },
        ...metaDados(this.$route),
      ],
    };
  },
  mixins: [mixinAtoAdministrativo],
  data() {
    return {
      carregando: true,
      erro: false,
      anos: [],
    };
  },
  components: {
    Loading,
    ErroResultados,
    PainelAnos,
  },
  created() {
    this.indexAtoAdministrativo = new IndexAtoAdministrativoApi();

    this.carregarAnos();
  },
  methods: {
    carregarAnos: async function () {
      try {
        if (this.indexAtoAdministrativo.cancelTokens.getAnos) {
          this.indexAtoAdministrativo.cancelTokens.getAnos.cancel();
        }

        this.carregando = true;
        this.erro = false;
        this.anos = await this.indexAtoAdministrativo.getAnos();
        this.carregando = false;
      } catch (err) {
        if (this.indexAtoAdministrativo.isCancel(err)) {
          return;
        }
        console.log(err);
        this.erro = true;
        this.carregando = false;
      }
    },
    generateUrl: function (ano) {
      return {
        name: "PesquisaIndexAtoAdministrativo",
        query: { ano },
      };
    },
  },
};
</script>

<style lang="scss" scoped>
h1 {
  background-color: #ffb24e;
  width: fit-content;
  border-radius: 12px;
  color: #115810;
  font-size: 1.5rem;
  padding: 0 0.3rem;
  margin: 2rem 0rem 1.5rem 0.5rem;
}
.tipo {
  min-height: calc(100vh - 10rem);
  margin-bottom: 5rem;
}
</style>
